import "./App.css";
import Home from "./mainComponents/Home";
import Footer from "./mainComponents/Footer";

function App() {
	return (
		<div className="main">
			<Home />
			<Footer />
		</div>
	);
}

export default App;
